var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSenseLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 32,
    viewBox: "0 0 117 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5617 25.8381C13.6998 25.6797 13.8352 25.5185 13.9732 25.3573L3.20034 10.3418C1.21087 12.6411 0 15.6738 0 18.9992C0 22.2414 1.15098 25.2015 3.05452 27.4794C7.4501 30.7377 12.0488 27.5976 13.5617 25.8381Z",
    fill: "url(#paint0_linear_13237_5576)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1528 16.8367L15.5902 15.2761L30.3472 0L19.7931 8.31629C17.7541 6.85503 15.2803 5.99547 12.6086 5.99547C10.3509 5.99547 8.23382 6.61059 6.40059 7.68236L4.12988 6.13246L12.4992 15.0263L14.1528 16.8367Z",
    fill: "url(#paint1_linear_13237_5576)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5617 25.8379C12.0488 27.5973 7.45011 30.7374 3.05192 27.4791C3.04932 27.4764 3.04671 27.4737 3.0415 27.471L3.25243 27.7182C3.25503 27.7209 3.26024 27.7262 3.26285 27.7289C3.40346 27.8874 3.54668 28.0432 3.69511 28.1963C3.71855 28.2205 3.74199 28.242 3.76542 28.2661C3.89041 28.3924 4.01801 28.5186 4.14821 28.6422C4.2029 28.6932 4.26019 28.7416 4.31487 28.7926C4.41643 28.884 4.51798 28.9753 4.62214 29.0639C4.68725 29.1203 4.75495 29.1714 4.82005 29.2251C4.919 29.3057 5.01535 29.3836 5.1143 29.4615C5.18461 29.5152 5.26013 29.5689 5.33304 29.62C5.432 29.6925 5.52834 29.7623 5.6299 29.8322C5.70542 29.8859 5.78354 29.9342 5.86166 29.9853C5.96061 30.0497 6.05956 30.1142 6.16112 30.176C6.24185 30.2243 6.32257 30.2727 6.4059 30.321C6.50746 30.3801 6.60901 30.4392 6.71317 30.4956C6.7965 30.5413 6.88243 30.5843 6.96576 30.6299C7.06992 30.6837 7.17409 30.7374 7.28085 30.7884C7.36678 30.8287 7.45532 30.8717 7.54125 30.9093C7.64802 30.9577 7.75478 31.0033 7.86415 31.049C7.95269 31.0866 8.04122 31.1215 8.13236 31.1564C8.24173 31.1994 8.35371 31.2397 8.46308 31.28C8.55422 31.3122 8.64275 31.3445 8.7365 31.374C8.84847 31.4116 8.96305 31.4465 9.07762 31.4815C9.16877 31.5083 9.25991 31.5379 9.35365 31.562C9.47083 31.5943 9.58801 31.6238 9.7078 31.6507C9.79894 31.6722 9.89008 31.6963 9.98382 31.7151C10.1062 31.742 10.2286 31.7635 10.3536 31.7877C10.4447 31.8038 10.5333 31.8226 10.6244 31.8387C10.7546 31.8602 10.8848 31.8763 11.0176 31.8924C11.1036 31.9032 11.1895 31.9166 11.2754 31.9274C11.4212 31.9435 11.5697 31.9542 11.7181 31.965C11.791 31.9703 11.8639 31.9784 11.9368 31.9811C12.1582 31.9918 12.3821 31.9999 12.6087 31.9999H12.6113C12.8144 31.9999 13.0149 31.9945 13.2128 31.9838C13.2675 31.9811 13.3248 31.9757 13.3795 31.973C13.5279 31.965 13.6737 31.9515 13.8195 31.9381C13.8794 31.9327 13.9393 31.9247 13.9992 31.9193C14.1424 31.9032 14.2831 31.8844 14.4237 31.8629C14.481 31.8548 14.5409 31.8468 14.5981 31.836C14.7388 31.8118 14.8794 31.7877 15.0174 31.7581C15.0747 31.7474 15.132 31.7366 15.1893 31.7232C15.3117 31.6963 15.434 31.6668 15.5538 31.6372C19.8531 30.5628 23.0482 27.1997 24.5143 23.2726C24.5221 23.2511 24.5299 23.2296 24.5377 23.2081C26.837 16.9548 28.777 6.06787 28.777 6.06787C28.777 6.06787 21.1941 16.8715 13.9732 25.349C13.8352 25.5182 13.6998 25.6794 13.5617 25.8379Z",
    fill: "url(#paint2_linear_13237_5576)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6496 9.66386L50.8808 10.9311C50.2824 10.1567 49.6576 9.60226 49.0064 9.26786C48.3728 8.91586 47.5544 8.73986 46.5512 8.73986C45.4424 8.73986 44.5712 8.98626 43.9376 9.47906C43.3216 9.95426 43.0136 10.6583 43.0136 11.5911C43.0136 12.5767 43.348 13.3159 44.0168 13.8087C44.6856 14.3015 45.7856 14.6887 47.3168 14.9703C49.2704 15.3047 50.696 15.8767 51.5936 16.6863C52.5088 17.4959 52.9664 18.6751 52.9664 20.2239C52.9664 20.8575 52.852 21.4647 52.6232 22.0455C52.412 22.6087 52.0776 23.1455 51.62 23.6559C51.1624 24.1663 50.52 24.5711 49.6928 24.8703C48.8832 25.1695 47.9328 25.3191 46.8416 25.3191C43.8848 25.3191 41.72 24.3247 40.3472 22.3359L42.2216 21.0423C42.8904 21.8519 43.5592 22.4239 44.228 22.7583C44.8968 23.0927 45.768 23.2599 46.8416 23.2599C49.4112 23.2599 50.696 22.2831 50.696 20.3295C50.696 19.3791 50.3704 18.6399 49.7192 18.1119C49.0856 17.5663 47.9768 17.1703 46.3928 16.9239C42.6264 16.3431 40.7432 14.5655 40.7432 11.5911C40.7432 10.1127 41.2448 8.92466 42.248 8.02706C43.2688 7.12946 44.7296 6.68066 46.6304 6.68066C49.3408 6.68066 51.3472 7.67506 52.6496 9.66386Z",
    fill: "#6673AC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2772 25.1079V6.89186H68.2596V8.95106H59.5476V14.6535H67.4676V16.7127H59.5476V23.0487H68.2596V25.1079H57.2772Z",
    fill: "#6673AC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4368 20.8047V6.89186H84.7072V25.1079H82.4896L74.6224 11.3271V25.1079H72.352V6.89186H74.5168L82.4368 20.8047Z",
    fill: "#6673AC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.226 9.66386L99.4568 10.9311C98.8584 10.1567 98.2336 9.60226 97.5824 9.26786C96.9488 8.91586 96.1304 8.73986 95.1272 8.73986C94.0184 8.73986 93.1472 8.98626 92.5136 9.47906C91.8976 9.95426 91.5896 10.6583 91.5896 11.5911C91.5896 12.5767 91.924 13.3159 92.5928 13.8087C93.2616 14.3015 94.3616 14.6887 95.8928 14.9703C97.8464 15.3047 99.272 15.8767 100.17 16.6863C101.085 17.4959 101.542 18.6751 101.542 20.2239C101.542 20.8575 101.428 21.4647 101.199 22.0455C100.988 22.6087 100.654 23.1455 100.196 23.6559C99.7384 24.1663 99.096 24.5711 98.2688 24.8703C97.4592 25.1695 96.5088 25.3191 95.4176 25.3191C92.4608 25.3191 90.296 24.3247 88.9232 22.3359L90.7976 21.0423C91.4664 21.8519 92.1352 22.4239 92.804 22.7583C93.4728 23.0927 94.344 23.2599 95.4176 23.2599C97.9872 23.2599 99.272 22.2831 99.272 20.3295C99.272 19.3791 98.9464 18.6399 98.2952 18.1119C97.6616 17.5663 96.5528 17.1703 94.9688 16.9239C91.2024 16.3431 89.3192 14.5655 89.3192 11.5911C89.3192 10.1127 89.8208 8.92466 90.824 8.02706C91.8448 7.12946 93.3056 6.68066 95.2064 6.68066C97.9168 6.68066 99.9232 7.67506 101.226 9.66386Z",
    fill: "#6673AC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.853 25.1079V6.89186H116.836V8.95106H108.124V14.6535H116.044V16.7127H108.124V23.0487H116.836V25.1079H105.853Z",
    fill: "#6673AC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13237_5576",
    x1: 13.3421,
    y1: 32.7696,
    x2: 23.8748,
    y2: 12.3456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE1E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3511,
    stopColor: "#EF4136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6439,
    stopColor: "#F68B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#F78E20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8284,
    stopColor: "#F89627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9206,
    stopColor: "#FAA535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#FBB040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13237_5576",
    x1: 27.5177,
    y1: 32.0007,
    x2: 30.3795,
    y2: 8.27428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE1E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3511,
    stopColor: "#EF4136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6439,
    stopColor: "#F68B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#F78E20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8225,
    stopColor: "#F89627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9117,
    stopColor: "#FAA535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9625,
    stopColor: "#FBB040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13237_5576",
    x1: 3.14658,
    y1: 32.6187,
    x2: 30.0955,
    y2: 32.6187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    stopColor: "#EF4136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9214,
    stopColor: "#F68B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9434,
    stopColor: "#F78E20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9655,
    stopColor: "#F89627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9875,
    stopColor: "#FAA535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB040"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSenseLogo);
export default __webpack_public_path__ + "static/media/sense-logo.0c925c8fa09a9d13079a7b1bb8bcd0f7.svg";
export { ForwardRef as ReactComponent };